//#region src/modules/Scheduling/shared/shift-flags/types.ts
/** Tier → CSS color used by Badge `color` and the day-dot ring. */
var FLAG_TIER_COLOR = {
	minor: "#d97706",
	problem: "#dc2626"
};
//#endregion
export { FLAG_TIER_COLOR };

//# sourceMappingURL=types.js.map